var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0533 5.72V10.28C14.0533 11.0266 13.6533 11.72 13.0066 12.1L9.04661 14.3867C8.39994 14.76 7.59994 14.76 6.94661 14.3867L2.98661 12.1C2.33994 11.7267 1.93994 11.0333 1.93994 10.28V5.72C1.93994 4.97334 2.33994 4.27997 2.98661 3.89997L6.94661 1.61331C7.59327 1.23998 8.39327 1.23998 9.04661 1.61331L13.0066 3.89997C13.6533 4.27997 14.0533 4.96667 14.0533 5.72Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00011 7.33333C8.85799 7.33333 9.55344 6.63787 9.55344 5.77999C9.55344 4.92211 8.85799 4.22668 8.00011 4.22668C7.14223 4.22668 6.44678 4.92211 6.44678 5.77999C6.44678 6.63787 7.14223 7.33333 8.00011 7.33333Z",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 11.1066C10.6668 9.90665 9.4735 8.93335 8.00016 8.93335C6.52683 8.93335 5.3335 9.90665 5.3335 11.1066",
    stroke: "#1E293B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerReport);
export default __webpack_public_path__ + "static/media/CustomerReport.9986152b6f6f4b2506e8929a2cfbe6c4.svg";
export { ForwardRef as ReactComponent };